import React from 'react';
import { createUseStyles } from 'react-jss';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import LabelWithContent from '../../Fields/LabelWithContent/LabelWithContent';
import Label from '../../Fields/Label/Label';
import Popover from '../../Popover/Popover';
import RegularPopover from './Popovers/Regular';
import Input from '../../Fields/Input/Input';
import Select from '../../Fields/Select/Select';
import SwitchContent from '../../Fields/SwichContent/SwitchContent';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const FieldLabel = ({ label, title, description, }) => {
  return (
    <LabelWithContent
      label={label}
      wrapperStyle={{ marginBottom: 0, }}
      labelStyle={{ fontSize: 16, }}
      content={
        <Popover
          wrapperStyle={{ marginLeft: 5, }}
          content={
            <RegularPopover
              title={title}
              description={description}
            />
          }
        />
      }
    />
  );
};

const AdNewFormVehicle = (props) => {
  const {
    t,
    tReady,
  } = props;
  const styles = useStyles();

  if (!tReady) {
    return null;
  }
  return (
    <div className={styles.container}>
      <div className={styles.switchRow}>
        <div className={styles.leftColumn}>
          <FieldLabel
            label={t('metailic_lacquer')}
            title={t('metailic_lacquer')}
            description={t('original_lacquer_tooltip_description')}
          />
        </div>
        <SwitchContent name="metailic_lacquer" />
      </div>
      <div className={styles.switchRow}>
        <div className={`col-md-8 ${styles.leftColumn}`}>
          <FieldLabel
            label={t('damage_unrepaired')}
            title={t('damage_unrepaired')}
            description={t('original_lacquer_tooltip_description')}
          />
        </div>
        <SwitchContent name="damage_unrepaired" />
      </div>
      <div className={styles.switchRow}>
        <div className={styles.leftColumn}>
          <FieldLabel
            label={t('heated_grips')}
            title={t('heated_grips')}
            description={t('original_lacquer_tooltip_description')}
          />
        </div>
        <SwitchContent name="heated_grips" />
      </div>
      <div className={styles.switchRow}>
        <div className={styles.leftColumn}>
          <FieldLabel
            label={t('box')}
            title={t('box')}
            description={t('original_lacquer_tooltip_description')}
          />
        </div>
        <SwitchContent name="box" />
      </div>

      <div className={styles.switchRow}>
        <div className={styles.leftColumn}>
          <FieldLabel
            label={t('windshield')}
            title={t('windshield')}
            description={t('original_lacquer_tooltip_description')}
          />
        </div>
        <SwitchContent name="windshield" />
      </div>
      <div className={styles.switchRow}>
        <div className={styles.leftColumn}>
          <Label label={t('abs')} labelStyle={{ fontSize: 16, marginBottom: 0, }} />
        </div>
        <SwitchContent name="abs" />
      </div>
      <div className={styles.vehiclePriceRow}>
        <div className={styles.vehiclePriceCol} name="price">
          <Label
            label={t('price')}
          />
          <div className={styles.priceField}>
            <Field
              name="price"
              type="number"
              component={Input}
            />
          </div>
        </div>
        <div className={styles.vehiclePriceCol} name="tax_rate">
          <FieldLabel
            label={t('tax_rate')}
            title={t('tax_rate')}
            description={t('original_lacquer_tooltip_description')}
          />
          <Field
            name="vat_rate"
            options={t('tax_types', { returnObjects: true, })}
            component={Select}
          />
        </div>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    padding: '0px 15px',
  },
  leftColumn: {
    width: '100%',
    paddingLeft: 0,
  },
  rightColumn: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: 0,
    fontWeight: 600,
    marginLeft: '1em',
  },
  switchRow: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 15,
    borderBottom: '2px solid #f6f5f8',
    '&:not(:first-of-type)': {
      paddingTop: 15,
    },
  },
  switchWrapper: {
    marginLeft: 20,
    marginRight: 20,
  },
  vehiclePriceWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  vehiclePriceInputWrapper: {
    marginBottom: 0,
  },
  vehiclePriceCurrency: {
    marginLeft: 10,
    fontSize: 16,
    fontWeight: 600,
  },
  vehiclePriceRow: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginTop: 30,
  },
  vehiclePriceCol: {
    position: 'relative',
    width: 'clamp(350px, 48%, 100vh)',
  },
  priceField: {
    position: 'relative',
    '&:after': {
      content: '\'€\'',
      position: 'absolute',
      top: '10px',
      right: '10px',
      fontSize: '25px',
    },
  },
});

FieldLabel.propTypes = {
  label: PropTypes.string.isRequired,
  tReady: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

SwitchContent.propTypes = {
  name: PropTypes.string.isRequired,
};

AdNewFormVehicle.propTypes = {
  tReady: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  accidentFree: PropTypes.bool,
  currentNotWrecked: PropTypes.bool,
  currentDefects: PropTypes.bool,
  currentAccessories: PropTypes.bool,
  currentImportVehicle: PropTypes.bool,
};

AdNewFormVehicle.defaultProps = {
  accidentFree: null,
  currentNotWrecked: null,
  currentDefects: null,
  currentAccessories: null,
  currentImportVehicle: null,
};

export default withScopedTranslations('ad_vehicle_description')(AdNewFormVehicle);
